import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const TILE_STATUS = {
  ACTIVE: 'active',
  ARCHIVED: 'archive',
};

export const useTileStatusTabs = tileType => {
  const { t } = useTranslation('reports');
  const tabs = {
    active: {
      name: t('reports:components.tableTabs.liveTiles'),
      tooltip: t('reports:components.tableTabs.liveTilesTooltip', {
        tileType,
      }),
    },
    archived: {
      name: t('reports:components.tableTabs.archivedTiles'),
      tooltip: t('reports:components.tableTabs.archivedTilesTooltip', {
        tileType,
      }),
    },
  };

  const [activeTab, setActiveTab] = useState(tabs.active.name);
  const [tileStatus, setTileStatus] = useState(TILE_STATUS.ACTIVE);
  const [page, setPage] = useState(1);

  const handleTabClick = targetTab => {
    if (targetTab !== activeTab) {
      setPage(1);
    }
    setActiveTab(targetTab);
    if (targetTab === tabs.archived.name) {
      setTileStatus(TILE_STATUS.ARCHIVED);
    } else {
      setTileStatus(TILE_STATUS.ACTIVE);
    }
  };

  return {
    activeTab,
    tileStatus,
    page,
    tabs,
    setPage,
    handleTabClick,
  };
};
